import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ShgnFooterMark from 'images/icons/shgn/ShgnFooterMark.svg'
import { ConfigConsumer } from 'contexts/config-context'
import { SettingsConsumer } from 'contexts/settings-context'

const Wrapper = styled.div`
  display: flex;
  flex-flow: ${p => p.isMobile ? 'column' : 'null'};
  justify-content: ${p => p.isMobile ? 'center' : 'space-between'};
  align-items: ${p => p.isMobile ? 'center' : 'flex-end'};
  height: ${p => p.isMobile ? 'auto' : '52px'};
  border-bottom: 1px solid rgba(204, 205, 206, 1);
`

const ItemsList = styled.ul`
  display:flex;
  align-items: ${p => p.isMobile ? 'center' : 'null'};
  flex-flow: ${p => p.isMobile ? 'column' : 'null'};
  margin: ${p => p.isMobile ? '15px auto 4px auto' : '0 0 12px 12px'};
  padding: 0;
`

const NavItem = styled.li`
  display: inline-block;
  padding: ${p => p.isMobile ? '0 0 22px 0' : '0 0 0 24px'};
`

const ShgnLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${p => p.isMobile ? ' 0 0 24px 0' : '0 36px 6px 0'};
  width: 217px;

  img {
      width: 100%;
  }
`

const A = styled.a`
  text-decoration: none;
`

const StyledLink = styled.div`
  font-family: 'Arial';
  font-size: 14px;
  color: rgba(204, 205, 206, 1);

`

function FooterLinks (props) {
  const { isMobile } = props
  return (
    <Wrapper isMobile={isMobile} >
      <ItemsList isMobile={isMobile}>
        {
          <ConfigConsumer>
            {config => (
              config.footerItems && config.footerItems.map((navItem, index) => {
                return (
                  <NavItem key={index} isMobile={isMobile}>
                    <A href={navItem.url}>
                      <StyledLink>{navItem.text}</StyledLink>
                    </A>
                  </NavItem>
                )
              })
            )}
          </ConfigConsumer>

        }
      </ItemsList>
      <SettingsConsumer>
        {settings => {
          return (
            <ShgnLogo isMobile={isMobile}>
              <A href="https://www.shgn.com/">
                <img src={`${settings.HOSTNAME}${ShgnFooterMark}`} />
              </A>
            </ShgnLogo>
          )
        }}
      </SettingsConsumer>
    </Wrapper>

  )
}

FooterLinks.propTypes = {
  isMobile: PropTypes.bool,
}

export default FooterLinks



// WEBPACK FOOTER //
// ./src/organisms/Footer/components/FooterLinks.js